import React, { FC, useEffect, useRef, useState } from 'react';

import { styled } from '../theme';
import Text from './Text';
import Tooltip from './Tooltip';

const StyledText = styled(Text.withComponent('b'))(({ theme }) => ({
    fontSize: '1.5rem',
    fontWeight: theme.typography.fontWeight.bold,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block',
}));

type Props = {
    className?: string;
    account: {
        first_name: string;
        last_name: string;
    };
};

export const AccountName: FC<Props> = ({ account, className }) => {
    const fullName = `${account.first_name} ${account.last_name}`.trim();
    const ref = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        if (ref.current) {
            setIsTruncated(ref.current.offsetWidth < ref.current.scrollWidth);
        }
    }, []);

    return (
        <Tooltip title={fullName} trigger={isTruncated ? 'hover' : 'none'}>
            <StyledText ref={ref} data-private data-testid="account-name" className={className}>
                {fullName}
            </StyledText>
        </Tooltip>
    );
};

export default AccountName;
